/**
 * TASK-19 · IndexedDB queue for offline grade-card batches.
 *
 * Store "pending_batches" (keyPath "local_id") holds batches that could not be
 * POSTed because the network was down. They are replayed on reconnect with the
 * same local_id as the X-Idempotency-Key, so the backend never duplicates them.
 *
 * Plain IndexedDB (no `idb` dependency) to keep the bundle/lockfile untouched.
 */
export const DB_NAME = "gradecard-offline";
export const DB_VERSION = 1;
export const STORE = "pending_batches";

function openDB() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") {
      reject(new Error("IndexedDB no está disponible en este navegador."));
      return;
    }
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "local_id" });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

function run(mode, fn) {
  return openDB().then(
    (db) =>
      new Promise((resolve, reject) => {
        const store = db.transaction(STORE, mode).objectStore(STORE);
        const request = fn(store);
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
      })
  );
}

export function addPending(item) {
  return run("readwrite", (store) => store.add(item)).then(() => item);
}

export function getAllPending() {
  return run("readonly", (store) => store.getAll()).then((rows) => rows || []);
}

export function deletePending(localId) {
  return run("readwrite", (store) => store.delete(localId));
}

export function countPending() {
  return run("readonly", (store) => store.count()).then((n) => n || 0);
}
